import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG, CFG_CHROME } from '../../../../../theme/configurator-tokens';

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 20px 20px 0 0;
  border-bottom: 1px solid ${CFG_CHROME.sidebarBorder};
  padding: 24px 16px 16px;
  /* Frosted glass: identical treatment to the docked footer. A transparentish
     fill + a −45° light sheen over a blurred backdrop (the step content that
     scrolls beneath the docked header). The blur (Figma "Frost") + saturate
     (Refraction) ride on backdrop-filter; the inset highlight is the lit edge. */
  background-color: ${CFG_CHROME.dockGlassBg};
  background-image: ${CFG_CHROME.dockGlassSheen};
  box-shadow: inset 0 1px 0 0 ${CFG_CHROME.dockGlassHighlight};
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
`;

export const Names = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  font-size: 14px;
  line-height: 1.1;
`;

export const Name = styled(Text)<{ $active?: boolean }>`
  flex: 1;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ $active }) => ($active ? CFG.brandText : CFG_CHROME.stepInactive)};
`;

export const TrackWrap = styled.div`
  position: relative;
`;

export const Track = styled.div`
  height: 6px;
  width: 355px;
  max-width: 100%;
  border-radius: 68px;
  background: ${CFG_CHROME.trackBg};
  box-shadow: ${CFG_CHROME.trackShadow};
`;

export const Indicator = styled.div<{ $pct: number }>`
  position: absolute;
  top: 0;
  height: 6px;
  border-radius: 18px;
  background: ${CFG.brand};
  width: ${({ $pct }) => `${$pct}%`};
  transition: width 300ms ease;
`;

export const Labels = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
`;

export const LabelCell = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const StepLabel = styled(Text)<{ $active?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: ${({ $active }) => ($active ? CFG.base300 : CFG.base500)};
`;
